import React, {useState, useContext, useEffect} from "react"
import PropTypes from "prop-types"

import {SearchContext} from "../../../../context"

import "./FilterToggle.scss"

function FilterToggle(props) {
  // context
  const search = useContext(SearchContext)
  
  // state
  const [active, setActive] = useState(false)

  // make sure already assigned filters are set
  useEffect(() => {
    if(search.filter[props.group].items.includes(props.item)) {
      if(!active) {
        setActive(true)
      }
    }
  })

  // side effect
  useEffect(() => {
    setActive(false)
  }, [search.resetTimestamp])

  const onClick = () => {
    setActive(!active)
    props.onChange({group:props.group, item:props.item, active:!active})
  }

  let inner = null
  if(props.icon) {
    return (
      <div className={`c-filter-toggle icon ${active ? "active" : ""} ${props.className || ""}`} onClick={onClick}>
        <div className="inner">
          <div className="icon">{props.icon}</div>
        </div>
      </div>
    )
    
  }
  else {
    return (
      <div className={`c-filter-toggle text ${active ? "active" : ""} ${props.className || ""}`} onClick={onClick}>
        <div className="inner">
          <span>{props.label}</span>
        </div>
      </div>
    )
  }

  
}

FilterToggle.propTypes = {
  label:PropTypes.string.isRequired,
  icon:PropTypes.any,
  onChange:PropTypes.func.isRequired,
  item:PropTypes.string.isRequired
}

export default FilterToggle